import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column'
    },
    skeleton: {
      margin: theme.spacing(2),
      marginLeft: theme.spacing(3),
      margingRight: theme.spacing(3)
    },
    infoIcon: {
      height: 16,
      width: 16,
      paddingTop: theme.spacing() / 2,
      color: theme.palette.secondary.main
    },
    titleContainer: {
      marginBottom: theme.spacing(2)
    },
    noPrint: {
      '@media print': { display: 'none' }
    }
  };
});

export default useStyles;
